(function () {
  var ENDPOINT = '/apps/reviews/submit';

  var root = document.getElementById('native-reviews');
  if (!root) return;

  var modal = document.getElementById('native-reviews-modal');
  var openBtn = document.getElementById('native-reviews-open');
  var form = document.getElementById('native-reviews-form');
  var msg = document.getElementById('native-reviews-msg');
  var submitBtn = document.getElementById('native-reviews-submit');
  var ratingInput = document.getElementById('native-reviews-rating');
  var ratingButtons = document.querySelectorAll('#native-reviews-rating-input .star-btn');
  var photoInput = document.getElementById('native-reviews-photo');

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openModal);
  modal.querySelectorAll('[data-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  ratingButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = parseInt(btn.getAttribute('data-value'), 10);
      ratingInput.value = value;
      ratingButtons.forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-value'), 10) <= value);
      });
    });
  });

  function showMsg(text, type) {
    msg.textContent = text;
    msg.hidden = false;
    msg.className = 'native-reviews__form-msg is-' + type;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (form.website.value) return; // honeypot

    var rating = parseInt(ratingInput.value, 10);
    if (!rating || rating < 1 || rating > 5) {
      showMsg('Por favor selecciona una calificación.', 'error');
      return;
    }

    var authorName = form.author_name.value.trim();
    var body = form.body.value.trim();

    if (!authorName || !body) {
      showMsg('Completa tu nombre y tu opinión.', 'error');
      return;
    }

    submitBtn.disabled = true;
    showMsg('Enviando...', 'ok');

    var photoFile = photoInput && photoInput.files && photoInput.files[0];
    var fetchOptions;

    if (photoFile) {
      var formData = new FormData();
      formData.append('product_id', root.getAttribute('data-product-id') || '');
      formData.append('product_handle', root.getAttribute('data-product-handle') || '');
      formData.append('rating', rating);
      formData.append('author_name', authorName);
      formData.append('body', body);
      formData.append('website', form.website.value || '');
      formData.append('photo', photoFile);
      fetchOptions = { method: 'POST', body: formData };
    } else {
      var payload = {
        product_id: root.getAttribute('data-product-id'),
        product_handle: root.getAttribute('data-product-handle'),
        rating: rating,
        author_name: authorName,
        body: body
      };
      fetchOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      };
    }

    fetch(ENDPOINT, fetchOptions)
      .then(function (res) {
        if (!res.ok) throw new Error('bad status');
        return res.json();
      })
      .then(function () {
        showMsg('¡Gracias! Tu opinión será publicada tras revisión.', 'ok');
        form.reset();
        ratingButtons.forEach(function (b) { b.classList.remove('is-active'); });
        setTimeout(closeModal, 1800);
      })
      .catch(function () {
        showMsg('No se pudo enviar tu opinión. Intenta de nuevo más tarde.', 'error');
        submitBtn.disabled = false;
      });
  });
})();
